export const REG_CONTACT_US_CLICKED = 'REG_CONTACT_US_CLICKED';

export const REG_FAQ_CLICKED = 'REG_FAQ_CLICKED';